import React, { useState } from "react";
import ParrotSlider from "@/components/ParrotSlider";
import OnboardingLayout from "./OnboardingLayout";

interface StudyHabitProps {
  dailyStudy: number;
  setDailyStudy: (minutes: number) => void;
}

const StudyHabit: React.FC<StudyHabitProps> = ({
  dailyStudy,
  setDailyStudy,
}) => {
  const [minutes, setMinutes] = useState(dailyStudy || 15);

  const handleMinutesChange = (value: number) => {
    setMinutes(value);
    setDailyStudy(value);
  };

  const getRecommendationType = (mins: number) => {
    if (mins <= 5) return "bg-orange-100 text-[var(--color-orange)]";
    if (mins <= 10) return "bg-[#f9f4c3] text-[var(--color-yellow)]";
    if (mins <= 15) return "bg-blue-100 text-[var(--color-blue)]";
    return "bg-green-100 text-[var(--color-green)]";
  };
  const getRecommendationText = (mins: number) => {
    if (mins <= 5) return "Slow and steady";
    if (mins <= 10) return "Good pace";
    if (mins <= 15) return "Recommended";
    return "Ambitious";
  };

  const calculateMonthlyWords = (mins: number) => {
    // 15 minutes ≈ 10 words, so we calculate proportionally
    const wordsPerDay = Math.round((mins / 15) * 10);
    return wordsPerDay * 30; // approximate words per month
  };

  return (
    <OnboardingLayout
      title="How Much Time Can You Study Each Day?"
      subtitle="Consistency matters. Even 5 minutes a day gets results."
    >
      <div className="flex flex-col items-center justify-center gap-8 w-full h-full">
      <div className="text-4xl font-bold my-5">{minutes} minutes</div>
      <ParrotSlider
        min={5}
        max={25}
        defaultValue={15}
        value={minutes}
        onChange={handleMinutesChange}
        step={5}
      />
      <div className="flex flex-col items-center gap-2">
        <div
          className={`p-2.5 rounded-full font-semibold font-nunito transition-all duration-300 w-40 text-center ${getRecommendationType(
            minutes
          )}`}
        >
          <div className="transition-opacity duration-300 whitespace-nowrap">
            {getRecommendationText(minutes)}
          </div>
        </div>
      </div>
      </div>

      <div className="inline-block px-4 py-2 rounded-full bg-[#DBEAFE] text-[var(--color-blue)] mb-6 transition-opacity duration-300">
          🧠 Learn ~{calculateMonthlyWords(minutes)} words each month
        </div>
    </OnboardingLayout>
  );
};

export default StudyHabit;
